import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import moment from 'moment'

import {LunaModal} from '../lunamodal.component'

import QuickChat from '../chat/quickchat.container'
import {ImageThumb} from './imagethumb.component'
import {Rating} from '../layout/rating.component'
import {LunaConfirm} from '../lunaconfirm.component'
import {AccommodationsEntry} from '../../accommodations/accommodationentry.component'
import {ActivityEntry} from '../../activities/activityentry.component'
import {TravelEntry} from '../../travel/travelentry.component'

export class ListItemBlock extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            statusModal: null
        }

        _.bindAll(this,
            'showModal',
            'onModalHide',
            'getDetails'
        )
    }	

    showModal(evt) {
        this.setState({
            showModal: true,
            statusModal: null
        })
    }

    onModalHide() {
        this.setState({
            showModal: false
        })
    }

    modalContent() {    
        switch (this.props.type) {
            case 'accommodation':
                return (
                    <div className="modal-content">
                        <i className="icon-close" onClick={ this.onModalHide }/>
                        <AccommodationsEntry {...this.props} onModalHide={this.onModalHide} isModal={true}/>
                    </div>
                ) 
                break
            case 'activity':
                return (
                    <div className="modal-content">
                        <i className="icon-close" onClick={ this.onModalHide }/>
                        <ActivityEntry {...this.props} onModalHide={this.onModalHide} isModal={true}/>
                    </div>
                ) 
                break
            case 'transportation':
                return (
                    <div className="modal-content">
                        <i className="icon-close" onClick={ this.onModalHide }/>
                        <TravelEntry {...this.props} detailSubDetail={this.props.subSection} onModalHide={this.onModalHide} isModal={true}/>
                    </div>
                ) 
                break
        }
    }

    getDetails() {
        if (this.props.type === 'accommodation') {
            return <Rating type="stars" itemCount={this.props.item.getIn(['accommodation_details', 'rating'])}/>
        } else if (this.props.type === 'activity') {
            let myDate = ''
            let myTime = ''
            if (this.props.item.getIn(['reservation_details', 'reservation_date'])) {
                myDate = moment(this.props.item.getIn(['reservation_details', 'reservation_date'])).format('MMM Do')
            }
            if (this.props.item.getIn(['reservation_details', 'reservation_time'])) {
                myTime = moment(this.props.item.getIn(['reservation_details', 'reservation_time'])).format('h:mm a')
            }
            return <div>{myDate} {myTime}</div>
        }
    }

    render() {
        let reservationBtn = <div className="btn btn-flex" onClick={this.showModal}><i className="icon-reservation"/><span>Reserve</span></div>

        if (this.props.type === 'transportation') {
            if (this.props.item.getIn(['transportation', 'reservation_details', 'confirmation_code'])) {
                reservationBtn = <div className="btn btn-flex btn-rose" onClick={this.showModal}><i className="icon-reservation"/><span>Reserved</span></div>
            }
            return (
                <div className="list-item-block">
                    <LunaModal statusModal={ this.state.statusModal } onModalHide={ this.onModalHide } showModal={ this.state.showModal } modalContent={this.modalContent()}/>
                    <div className="list-item-body">
                        <a onClick={() => this.props.showDetails(this.props.item)}><h1>{this.props.item.getIn(['transportation', 'name'])}</h1></a>
                        <div className="travel-icons-small">
                            {this.props.vehicles}
                            {this.props.itemDuration}
                        </div>                
                    </div>
                    <div className="list-item-details">
                        <div className="list-item-addedby">Added by {this.props.item.getIn(['added_by'])}</div>
                    </div>
                    <div className="list-item-actions">
                        {reservationBtn}
                        <div className="list-item-tools">
                            <LunaConfirm type="iconDelete" onConfirm={() => { this.props.onRemoveTransportation(this.props.item) }} mssg="Are you sure you want to delete this option?"/>                                 
                        </div>
                    </div>
                </div>
            )
        } else {
            if (this.props.item.getIn(['reservation_details', 'confirmation_code'])) {
                reservationBtn = <div className="btn btn-flex btn-rose" onClick={this.showModal}><i className="icon-reservation"/><span>Reserved</span></div>
            }

            return (
                <div className="list-item-block">
                    <LunaModal statusModal={ this.state.statusModal } onModalHide={ this.onModalHide } showModal={ this.state.showModal } modalContent={this.modalContent()}/>
                    <ImageThumb item={ this.props.item } showDetails={() => (this.props.showDetails(this.props.item)) }/>
                    <div className="list-item-body">
                        <a onClick={() => this.props.showDetails(this.props.item)}><h1>{this.props.item.getIn(['name'])}</h1></a>
                        <div className="list-item-addedby">Added by {this.props.item.getIn(['added_by'])}</div>
                    </div>
                    <div className="list-item-details">
                        {this.getDetails()}
                    </div>
                    <div className="list-item-actions">
                        {reservationBtn}
                        <div className="list-item-tools">
                            <LunaConfirm type="iconDelete" onConfirm={() => { this.props.removeFromItin() }} mssg="Are you sure you want to delete this item?"/>                                 
                            <QuickChat {...this.props} targetItem={this.props.item} targetItemType={ this.props.type }/>            
                        </div>
                    </div>
                </div>
            )
        }
    }
}
